import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, CardGroup } from 'react-bootstrap';
import "./Portfolio.css";

const Portfolio = () => {
    const [portfolio, setPortfolio] = useState([]);

    useEffect(() => {
        fetch("./portfolio.json")
            .then(res => res.json())
            .then(data => setPortfolio(data))

    }, []);
    return (
        <Container className="py-5">
            <h2 className="py-3">Portfolio</h2>
            <Row xs={1} sm={3} md={4} className="g-2">
                {portfolio.map(portfoli => <Col className="content">
                    <CardGroup className="g-2">
                        <Card className="screen">
                            <a href={portfoli.link} target="_blank">
                                <Card.Img variant="top" src={portfoli.img} />
                            </a>
                        </Card>
                    </CardGroup>
                    <div className="overFlow d-flex justify-content-around">
                        <a href="#">Live site</a>
                        <a href="#">Code link</a>
                    </div>
                </Col>
                )}
            </Row>
        </Container>
    );
}

export default Portfolio;
